<template>

<div>

  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay=false>
      <v-btn color="primary" dark slot="activator">ログイン</v-btn>

      <v-btn   slot="activator" to="/user/profile">ログイン済み</v-btn>

      <v-card class="background">
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        <!-- The surrounding HTML is left untouched by FirebaseUI.
            Your app may use that space for branding, controls and other customizations.-->
        <h2 id="servicetitle">active hoop</h2>
        <div id="firebaseui-auth-container" class="pt-5"></div>
        <div id="loader">Loading...</div>
        <p id="termmessage">利用規約に同意して、登録・ログインする</p>
        

      </v-card>


    </v-dialog>
  </v-layout>




</div>
</template>


<script>
import firebase from 'firebase'
import firebaseui from 'firebaseui'

export default {
  name: 'login',
  components: {
    firebase,
    firebaseui
  },
  data () {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.

      } else {
        // No user is signed in.

      }
    })
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    }
  },
  mounted () {
    // Initialize Cloud Firestore through Firebase
    var db = firebase.firestore()

    // FirebaseUI config.
    var uiConfig = {
      callbacks: {
        signInSuccess: function (currentUser, credential, redirectUrl) {
          console.log(currentUser)
          console.log(credential)
          console.log(redirectUrl)
          alert(currentUser.displayName)
          alert(currentUser.email)
          // Do something.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.

          // firestore
          db.collection('users').add({
            uid: currentUser.uid,
            name: currentUser.displayName,
            email: currentUser.email,
            photoURL: currentUser.photoURL

          })
        .then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
        })
        .catch(function (error) {
          console.error('Error adding document: ', error)
        })

          return true
        },
        uiShown: function () {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById('loader').style.display = 'none'
        }
      },
    //    signInSuccessUrl: '<url-to-redirect-to-on-success>',
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
    //        Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID
    //        Firebase.auth.GithubAuthProvider.PROVIDER_ID
      ],
      // Terms of service url.
      tosUrl: '<your-tos-url>'
    }

    // Initialize the FirebaseUI Widget using Firebase.
    var ui = new firebaseui.auth.AuthUI(firebase.auth())
    // The start method will wait until the DOM is loaded.
    ui.start('#firebaseui-auth-container', uiConfig)
  }
}

</script>

<style scoped>
  div.background {
    color:#000000;
    background-color: #3399FF;
    background-image: url("/static/loginback.jpg")
  }
  #servicetitle {
    text-align: center;
    color: white;
    font-size: 50px;
    font-family: 'Oswald', sans-serif;
  }
  #termmessage {
    text-align: center; 
  }
</style>


<style src="firebaseui/dist/firebaseui.css"></style>





// WEBPACK FOOTER //
// src/components/Login.vue